module.exports = __webpack_public_path__ + "static/media/Rollo 2.79f226ac.jpg";